<div class="company-filter-wrapper kendo-formfield">
  <div class="filter-row">
    <div class="operator-dropdown">
      <kendo-label text="Company Name"></kendo-label>
      <kendo-dropdownlist [data]="operators" [value]="operator" textField="text" valueField="value"
        [valuePrimitive]="true" fillMode="outline" (valueChange)="onOperatorChange($event)">
      </kendo-dropdownlist>
    </div>
    <div class="company-multiselect">
      <app-company-select-kendo label="" placeholder="Select company name" [selectedId]="selectedCompanyIds"
        [filters]="companyFilters" (selectionChanged)="onSelectionChanged($event)" (enteredPressed)="onEnterPressed()">
      </app-company-select-kendo>
    </div>
  </div>
</div>
